import { NgModule } from '@angular/core';
import { SharedLegModule } from '@approot/shared/shared-leg.module';
import { SharedModule } from '@approot/shared/shared.module';
import { AgCharts } from 'ag-charts-angular';
import { SaveStrategyComponent } from '../strategy-detail/modals/save-strategy/save-strategy.component';
import { DeltaByTenorComponent } from './../strategy-detail/modals/analytical-tools/delta-by-tenor/delta-by-tenor.component';
import { SpotLadderComponent } from './../strategy-detail/modals/analytical-tools/spot-ladder/spot-ladder.component';
import { SpotSpotMatrixComponent } from './../strategy-detail/modals/analytical-tools/spot-spot-matrix/spot-spot-matrix.component';
import { VegaByBucketComponent } from './../strategy-detail/modals/analytical-tools/vega-by-bucket/vega-by-bucket.component';
import { ShareStrategyModalComponent } from './../strategy-detail/modals/share-strategy/share-strategy-modal.component';
import { DcdResultsAttributesComponent } from './dcd-results-attributes/dcd-results-attributes.component';
import { ExtraResultsAttributesComponent } from './extra-results-attributes/extra-results-attributes.component';
import { MarketDataAttributesComponent } from './market-data-attributes/market-data-attributes.component';
import { PayoutGraphComponent } from './modals/analytical-tools/payout-graph/payout-graph.component';
import { RatesLadderComponent } from './modals/analytical-tools/rates-ladder/rates-ladder.component';
import { SpotLadderGraphComponent } from './modals/analytical-tools/spot-ladder/spot-ladder-graph/spot-ladder-graph.component';
import { MultiLegSolverComponent } from './modals/multi-leg-solver/multi-leg-solver.component';
import { LegMenuProductsPipe } from './pipes/leg-menu-products/leg-menu-products.pipe';
import { ResultsHeaderPipe } from './pipes/results-header/results-header.pipe';
import { PricingResultsAttributesComponent } from './pricing-results-attributes/pricing-results-attributes.component';
import { StrategyDetailTabsComponent } from './strategy-detail-tabs/strategy-detail-tabs.component';
import { StrategyDetailComponent } from './strategy-detail.component';
import { SumLegComponent } from './sum-leg/sum-leg.component';
import { SumResultsDisplayComponent } from './sum-leg/sum-results-display/sum-results-display.component';

@NgModule({
  declarations: [
    DcdResultsAttributesComponent,
    DeltaByTenorComponent,
    ExtraResultsAttributesComponent,
    LegMenuProductsPipe,
    MarketDataAttributesComponent,
    MultiLegSolverComponent,
    PayoutGraphComponent,
    PricingResultsAttributesComponent,
    RatesLadderComponent,
    SpotSpotMatrixComponent,
    ResultsHeaderPipe,
    SaveStrategyComponent,
    ShareStrategyModalComponent,
    SpotLadderComponent,
    SpotLadderGraphComponent,
    StrategyDetailComponent,
    StrategyDetailTabsComponent,
    SumLegComponent,
    SumResultsDisplayComponent,
    VegaByBucketComponent
  ],
  imports: [SharedModule, SharedLegModule, AgCharts],
  exports: [
    DeltaByTenorComponent,
    ExtraResultsAttributesComponent,
    MarketDataAttributesComponent,
    PricingResultsAttributesComponent,
    RatesLadderComponent,
    SaveStrategyComponent,
    ShareStrategyModalComponent,
    SpotLadderComponent,
    SpotLadderGraphComponent,
    SpotSpotMatrixComponent,
    StrategyDetailComponent,
    SumLegComponent,
    SumResultsDisplayComponent,
    VegaByBucketComponent
  ],
  providers: [LegMenuProductsPipe]
})
export class StrategyDetailModule {}
